// extracted by mini-css-extract-plugin
export default {"code":"code-Sscv4","codeMain":"code-main-Bf4rG","codeMainClose":"code-main-close-uCeBd","codeMainBtn":"code-main-btn-SdS9B"};